import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeTrackingService } from '../api/time-tracking.service';
import { TIME_TRACKING_KEYS } from './queryKeys';
import type { UserTimeEntriesQueryParams } from '../types';

/** Paginated time entries for a user, with optional date range (admin reports). */
export function useUserTimeEntries(userId: string | null, params: UserTimeEntriesQueryParams) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: TIME_TRACKING_KEYS.userEntries(orgId ?? '', userId ?? '', params),
    queryFn: ({ signal }) => timeTrackingService.getUserTimeEntries(userId!, params, signal),
    // Shared/collaborative data: always refetch on mount, filter change, and window focus
    staleTime: 0,
    refetchOnWindowFocus: true,
    enabled: !!orgId && !!userId,
    placeholderData: keepPreviousData,
  });
}
